import { render, staticRenderFns } from "./directoryMore.vue?vue&type=template&id=54dbf00d&scoped=true&"
import script from "./directoryMore.vue?vue&type=script&lang=js&"
export * from "./directoryMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dbf00d",
  null
  
)

export default component.exports